import { RequestHandlerParams } from "../../store";
import { BoostingCampaign } from "@vviinn/user-managment-client-ts";
import { deleteBoosting, upsertBoosting } from "../../store/features/campaigns/boostingRequests";
import { removeBoostingFromAllCampaigns } from "../../store/features/campaigns/campaigns-slice";
import { CampaignRequest } from "../../store/features/campaigns/types";

export const handleBoosting = (
  params: RequestHandlerParams,
  { companyId, siteId }: CampaignRequest,
) => {
  const { getApi, notify, dispatch } = params;

  return {
    async handleUpsertBoosting(boostingCampaign: BoostingCampaign) {
      notify("Info", "updating boosting");
      const api = await getApi();
      const response = await dispatch(
        upsertBoosting({ api, value: { companyId, siteId, boostingCampaign } }),
      );
      const isSuccess = response.meta.requestStatus === "fulfilled";
      if (isSuccess) notify("Success", "Boosting updated");
      else notify("Error", "Could not update boosting");
      if (response.payload) return response.payload as BoostingCampaign;
      return false;
    },

    async handleDeleteBoosting(boostingId?: string) {
      if (!boostingId) return false;
      notify("Info", "deleting boosting");
      const api = await getApi();
      const response = await dispatch(
        deleteBoosting({
          api,
          value: { companyId, siteId, campaignId: boostingId },
        }),
      );
      const isSuccess = response.meta.requestStatus === "fulfilled";
      if (isSuccess) {
        notify("Success", "Boosting deleted");
        dispatch(removeBoostingFromAllCampaigns(boostingId));
      } else notify("Error", "Could not delete boosting");
      return isSuccess;
    },
  };
};
